import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// If a deploy lands while a customer has the SPA open, their loaded entry
// chunk still references the old hashed URLs. Lazy navigations (admin
// routes, the guest registration wizard) will then 404 on the old file.
// Catch those failures and reload once -- the next load fetches the new
// index.html + new hashes and they're on the fresh version.
//
// Guarded by sessionStorage so a real network outage (where the reload
// itself can't get the new file either) doesn't loop forever.
const RELOAD_KEY = "hp:chunk-reload-at";
function reloadOnceForStaleChunk() {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? "0");
  if (Date.now() - last < 10_000) return;
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
}

function isChunkLoadError(reason: unknown): boolean {
  if (!reason) return false;
  const msg =
    reason instanceof Error
      ? `${reason.name}: ${reason.message}`
      : String(reason);
  return (
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("Importing a module script failed") ||
    msg.includes("error loading dynamically imported module") ||
    msg.includes("ChunkLoadError")
  );
}

window.addEventListener("vite:preloadError", reloadOnceForStaleChunk);
window.addEventListener("unhandledrejection", (e) => {
  if (isChunkLoadError(e.reason)) reloadOnceForStaleChunk();
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
